import { render, staticRenderFns } from "./PromoNew.vue?vue&type=template&id=d60463e4&scoped=true"
import script from "./PromoNew.vue?vue&type=script&lang=js"
export * from "./PromoNew.vue?vue&type=script&lang=js"
import style0 from "./PromoNew.vue?vue&type=style&index=0&id=d60463e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60463e4",
  null
  
)

export default component.exports